import { environment } from './environments/environment';

const cdnAssets = [
  'https://dle-cdn.mheducation.com/mhe/tinymce/6.8.2/tinymce.min.js'
];

export default cdnAssets;
